// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* .cancelBtn {
  width: 75px;
  height: 35px;
  margin: 0 10px;
  border-radius: 5px;
  cursor: pointer;
  background-color: #fff;
  border: 2px solid rgb(28, 57, 187);
}
.darkThemeCancelBtn {
  border: 2px solid #2e4060;
}
.brightThemeCancelBtn {
  border: 2px solid rgb(28, 57, 187);
}
.updateBtn {
  width: 75px;
  height: 35px;
  margin: 0 10px;
  border-radius: 5px;
  cursor: pointer;
  color: #fff;
  background-color: #3963b8;
  border: 1px solid #2e4060;
}
.deleteBtn {
  width: 75px;
  height: 35px;
  margin: 0 10px;
  border-radius: 5px;
  cursor: pointer;
  background-color: #bbc0ca;
  color: #fff;
  border: none;
  font-weight: 500;
}
.submitAddBtn {
  width: 75px;
  height: 35px;
  margin: 0 10px;
  border-radius: 5px;
  cursor: pointer;
}
.darkThemeSubmitBtn {
  color: #fff;
  background-color: #3963b8;
  border: 1px solid #2e4060;
}
.brightThemeSubmitBtn {
  color: #fff;
  background-color: rgb(28, 57, 187);
  border: 1px solid rgb(28, 57, 187);
} */
.formActionSection_formSubmitContainer__J7v\\+d {
  margin-bottom: 20px !important;
  display: flex !important;
  justify-content: flex-end !important;
  padding: 50px 15px 15px 15px !important;
  column-gap: 24px;
}
.formActionSection_submitBtn__kX54M {
  width: 100px;
  height: 38px;
  border-radius: 5px;
  color: #fafafa;
  cursor: pointer;
  background-color: #3963b8;
  border: none;
  font-weight: 500;
  font-size: 16px;
}
.formActionSection_cancelBtn__bIWcp {
  width: 100px;
  height: 38px;
  border-radius: 5px;
  cursor: pointer;
  color: #787878;
  border: 1px solid #787878;
  background-color: #fff;
  font-weight: 500;
  font-size: 16px;
}
.formActionSection_deleteBtn__1rLbi {
  width: 100px;
  height: 38px;
  border-radius: 5px;
  cursor: pointer;
  color: #cc3232;
  border: 1px solid #cc3232;
  background-color: #fff;
  font-weight: 500;
  font-size: 16px;
}
@media all and (max-width: 600px) {
  .formActionSection_submitBtn__kX54M,
  .formActionSection_cancelBtn__bIWcp,
  .formActionSection_deleteBtn__1rLbi {
    font-weight: 400;
    font-size: 14px;
    width: 80px;
    height: 30px;
  }
}
@media all and (max-width: 350px) {
  .formActionSection_formSubmitContainer__J7v\\+d {
    padding: 25px 5px 20px 5px !important;
    column-gap: 12px;
  }
  .formActionSection_submitBtn__kX54M,
  .formActionSection_cancelBtn__bIWcp,
  .formActionSection_deleteBtn__1rLbi {
    font-weight: 400;
    font-size: 12px;
    width: 70px;
    height: 25px;
  }
}
`, "",{"version":3,"sources":["webpack://./src/Components/UI/FormActionSection/formActionSection.module.css"],"names":[],"mappings":"AAAA;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;GAoDG;AACH;EACE,8BAA8B;EAC9B,wBAAwB;EACxB,oCAAoC;EACpC,uCAAuC;EACvC,gBAAgB;AAClB;AACA;EACE,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,cAAc;EACd,eAAe;EACf,yBAAyB;EACzB,YAAY;EACZ,gBAAgB;EAChB,eAAe;AACjB;AACA;EACE,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,cAAc;EACd,yBAAyB;EACzB,sBAAsB;EACtB,gBAAgB;EAChB,eAAe;AACjB;AACA;EACE,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,cAAc;EACd,yBAAyB;EACzB,sBAAsB;EACtB,gBAAgB;EAChB,eAAe;AACjB;AACA;EACE;;;IAGE,gBAAgB;IAChB,eAAe;IACf,WAAW;IACX,YAAY;EACd;AACF;AACA;EACE;IACE,qCAAqC;IACrC,gBAAgB;EAClB;EACA;;;IAGE,gBAAgB;IAChB,eAAe;IACf,WAAW;IACX,YAAY;EACd;AACF","sourcesContent":["/* .cancelBtn {\r\n  width: 75px;\r\n  height: 35px;\r\n  margin: 0 10px;\r\n  border-radius: 5px;\r\n  cursor: pointer;\r\n  background-color: #fff;\r\n  border: 2px solid rgb(28, 57, 187);\r\n}\r\n.darkThemeCancelBtn {\r\n  border: 2px solid #2e4060;\r\n}\r\n.brightThemeCancelBtn {\r\n  border: 2px solid rgb(28, 57, 187);\r\n}\r\n.updateBtn {\r\n  width: 75px;\r\n  height: 35px;\r\n  margin: 0 10px;\r\n  border-radius: 5px;\r\n  cursor: pointer;\r\n  color: #fff;\r\n  background-color: #3963b8;\r\n  border: 1px solid #2e4060;\r\n}\r\n.deleteBtn {\r\n  width: 75px;\r\n  height: 35px;\r\n  margin: 0 10px;\r\n  border-radius: 5px;\r\n  cursor: pointer;\r\n  background-color: #bbc0ca;\r\n  color: #fff;\r\n  border: none;\r\n  font-weight: 500;\r\n}\r\n.submitAddBtn {\r\n  width: 75px;\r\n  height: 35px;\r\n  margin: 0 10px;\r\n  border-radius: 5px;\r\n  cursor: pointer;\r\n}\r\n.darkThemeSubmitBtn {\r\n  color: #fff;\r\n  background-color: #3963b8;\r\n  border: 1px solid #2e4060;\r\n}\r\n.brightThemeSubmitBtn {\r\n  color: #fff;\r\n  background-color: rgb(28, 57, 187);\r\n  border: 1px solid rgb(28, 57, 187);\r\n} */\r\n.formSubmitContainer {\r\n  margin-bottom: 20px !important;\r\n  display: flex !important;\r\n  justify-content: flex-end !important;\r\n  padding: 50px 15px 15px 15px !important;\r\n  column-gap: 24px;\r\n}\r\n.submitBtn {\r\n  width: 100px;\r\n  height: 38px;\r\n  border-radius: 5px;\r\n  color: #fafafa;\r\n  cursor: pointer;\r\n  background-color: #3963b8;\r\n  border: none;\r\n  font-weight: 500;\r\n  font-size: 16px;\r\n}\r\n.cancelBtn {\r\n  width: 100px;\r\n  height: 38px;\r\n  border-radius: 5px;\r\n  cursor: pointer;\r\n  color: #787878;\r\n  border: 1px solid #787878;\r\n  background-color: #fff;\r\n  font-weight: 500;\r\n  font-size: 16px;\r\n}\r\n.deleteBtn {\r\n  width: 100px;\r\n  height: 38px;\r\n  border-radius: 5px;\r\n  cursor: pointer;\r\n  color: #cc3232;\r\n  border: 1px solid #cc3232;\r\n  background-color: #fff;\r\n  font-weight: 500;\r\n  font-size: 16px;\r\n}\r\n@media all and (max-width: 600px) {\r\n  .submitBtn,\r\n  .cancelBtn,\r\n  .deleteBtn {\r\n    font-weight: 400;\r\n    font-size: 14px;\r\n    width: 80px;\r\n    height: 30px;\r\n  }\r\n}\r\n@media all and (max-width: 350px) {\r\n  .formSubmitContainer {\r\n    padding: 25px 5px 20px 5px !important;\r\n    column-gap: 12px;\r\n  }\r\n  .submitBtn,\r\n  .cancelBtn,\r\n  .deleteBtn {\r\n    font-weight: 400;\r\n    font-size: 12px;\r\n    width: 70px;\r\n    height: 25px;\r\n  }\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"formSubmitContainer": `formActionSection_formSubmitContainer__J7v+d`,
	"submitBtn": `formActionSection_submitBtn__kX54M`,
	"cancelBtn": `formActionSection_cancelBtn__bIWcp`,
	"deleteBtn": `formActionSection_deleteBtn__1rLbi`
};
export default ___CSS_LOADER_EXPORT___;
